<template>
  <div class="container">
    <div v-if="$store.getters.user != null" class="row">
      <div class="col">
        <button
          v-if="page == 2"
          class="btn btn-link nav-link"
          v-on:click="changePage(1)"
        >
          Back to All Accounts
        </button>
      </div>
    </div>
    <div v-if="page == 1">
      <div
        class="row pt-3"
        v-for="(account, index) in accounts"
        :key="account.Account_Id"
        v-bind:class="{ 'light-background': index % 2 === 1 }"
      >
        <div class="col">
          <div class="row text-left">
            <div class="col-auto px-0">
              <i
                class="material-icons pointer"
                v-bind:id="account.Account_Id + 'accountToggleIcon'"
                data-toggle="collapse"
                v-bind:href="'#accountDetails' + account.Account_Id"
                role="button"
                aria-expanded="false"
                v-on:click="showAccountDetails(account.Account_Id)"
                >add</i
              >
            </div>
            <div class="col">
              <h6 class="pointer d-inline-block">
                {{ account.basics.Account_Name }}
              </h6>
            </div>
          </div>
          <div class="row">
            <div
              class="container collapse ml-4"
              v-bind:id="'accountDetails' + account.Account_Id"
            >
              <div
                class="mb-3"
                style="background-color:gray; height:1px; width:100%"
              />
              <ManageAccountDetails
                v-if="account.details != null"
                v-bind:Account="account.details"
                v-bind:Permissions="permissions"
                v-bind:AccountVariables="accountVariables"
                @manage-organization-permissions="manageOrganizationPermissions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <UserPermissions
      v-if="page == 2"
      v-bind:Organization="permissionsOrganization"
    />
  </div>
</template>

<script>
import ManageAccountDetails from "@/components/Account/ManageAccountDetails.vue";
import UserPermissions from "@/components/User/UserPermissions.vue";
import $ from "jquery";

export default {
  name: "AccountManagement",
  components: {
    ManageAccountDetails,
    UserPermissions
  },
  watch: {
    "$store.getters.user": async function() {
      this.loadAccounts();
    }
  },
  data() {
    return {
      page: 1,
      accounts: [],
      permissionsOrganization: null,
      accountVariables: null,
      permissions: []
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    var view = this;
    await this.$getAccountVariables().then(variables => {
      view.accountVariables = variables;
    });
    await this.loadAccounts();
  },
  methods: {
    async loadAccounts() {
      var view = this;
      if (
        this.$store.getters.user != null &&
        !this.$store.getters.user.Organizations.some(o =>
          this.$canSeeAccountSettings(
            this.$store.getters.user.Permissions,
            o.Account.Account_Id
          )
        )
      ) {
        this.$showSnackbar(
          "It looks like you don't have permission to go to that page.",
          true
        );
        this.$router.replace({ name: "dashboard" });
        this.$store.commit("updateLoading", false);
      }
      if (view.$store.getters.user != null) {
        view.permissions = await this.$getAllPermissions();
        await view
          .$getMyAccountsBasic()
          .then(accounts => {
            view.accounts = [];
            accounts.forEach(accountBasics => {
              view.accounts.push({
                Account_Id: accountBasics.Account_Id,
                basics: accountBasics,
                details: null
              });
            });
          })
          .then(async () => {
            if (view.$route.params.id) {
              await this.showAccountDetails(view.$route.params.id).then(() => {
                var elmnt = document.getElementById(
                  "accountDetails" + view.$route.params.id
                );
                elmnt.scrollIntoView({
                  behavior: "smooth",
                  block: "center"
                });
                $("#accountDetails" + view.$route.params.id).collapse("show");
              });
            } else {
              view.$store.commit("updateLoading", false);
            }
          })
          .catch(e => {
            console.log(e);
            view.$store.commit("updateLoading", false);
          });
      }
    },
    changePage(num) {
      this.permissionsAccountId = -1;
      this.page = num;
    },
    async showAccountDetails(accountId) {
      var view = this;
      var accountIndex = view.accounts.findIndex(
        a => a.Account_Id == accountId
      );
      if (view.accounts[accountIndex].details == null) {
        view.$store.commit("updateLoading", true);
        await view.$getAccount(accountId).then(account => {
          var accountTypeOrganizationType = view.accountVariables.Account_Type_Organization_Types.find(
            t => t.Account_Type_Id == account.Account_Type.Account_Type_Id
          );
          account.organizationTypes = view.accountVariables.Organization_Types.filter(
            t => t.Order >= accountTypeOrganizationType.Organization_Type.Order
          );
          view.accounts[accountIndex].details = account;
          if (view.$route.params.id != account.Account_Id) {
            view.$router.replace({ params: { id: account.Account_Id } });
          }

          view.$store.commit("updateLoading", false);
          view.$updateToggleIcon("#" + accountId + "accountToggleIcon");
        });
      } else {
        view.$updateToggleIcon("#" + accountId + "accountToggleIcon");
      }
    },
    selectAccount(accountId) {
      this.page = -1;
      this.accountId = accountId.toString();
    },
    manageOrganizationPermissions(organization) {
      console.log(this.accounts[0].details);
      organization.Account = this.accounts.find(a =>
        a.details.Organizations.map(o => o.Organization_Id).includes(
          organization.Organization_Id
        )
      );
      this.permissionsOrganization = organization;
      this.changePage(2);
      console.log(organization);
    }
  }
};
</script>
